import React, { useState, useEffect, useRef } from 'react';
import Matter from 'matter-js';
import './Drawing.css';
import Modal1 from './Drawing/Modal_1';
import Modal2 from './Drawing/Modal_2';

import poster1 from "../../../asset/poster1.png";
import poster2 from "../../../asset/poster2.png";
import poster3 from "../../../asset/poster3.png";
import poster4 from "../../../asset/poster4.png";

import grab from "../../../asset/grab.png";
import pointer from "../../../asset/pointer.png";
import cursor from "../../../asset/cursor.png";

import x from "../../../asset/x.svg";

import ex1ph1 from "../../../asset/1stExhibition/ph1.png"
import ex1ph2 from "../../../asset/1stExhibition/ph2.png"
import ex1ph3 from "../../../asset/1stExhibition/ph3.png"
import ex1ph4 from "../../../asset/1stExhibition/ph4.png"
import ex1ph5 from "../../../asset/1stExhibition/ph5.png"
import ex1ph6 from "../../../asset/1stExhibition/ph6.png"
import ex1ph7 from "../../../asset/1stExhibition/ph7.png"
import ex1ph8 from "../../../asset/1stExhibition/ph8.png"
import ex1ph9 from "../../../asset/1stExhibition/ph9.png"
import ex1ph10 from "../../../asset/1stExhibition/ph10.png"
import ex1ph11 from "../../../asset/1stExhibition/ph11.png"
import ex1ph12 from "../../../asset/1stExhibition/ph12.png"
import ex1ph13 from "../../../asset/1stExhibition/ph13.png"
import ex1ph14 from "../../../asset/1stExhibition/ph14.png"
import ex1ph15 from "../../../asset/1stExhibition/ph15.png"

import ex2ph1 from "../../../asset/2ndExhibition/ph1.png";
import ex2ph2 from "../../../asset/2ndExhibition/ph2.png";
import ex2ph3 from "../../../asset/2ndExhibition/ph3.png";
import ex2ph4 from "../../../asset/2ndExhibition/ph4.png";
import ex2ph5 from "../../../asset/2ndExhibition/ph5.png";
import ex2ph6 from "../../../asset/2ndExhibition/ph6.png";
import ex2ph7 from "../../../asset/2ndExhibition/ph7.png";
import ex2ph8 from "../../../asset/2ndExhibition/ph8.png";
import ex2ph9 from "../../../asset/2ndExhibition/ph9.png";
import ex2ph10 from "../../../asset/2ndExhibition/ph10.png";

import ex3ph1 from "../../../asset/3rdExhibition/ph1.png";
import ex3ph2 from "../../../asset/3rdExhibition/ph2.png";

import ex4ph1 from "../../../asset/4thExhibition/ph1.png";
import ex4ph2 from "../../../asset/4thExhibition/ph2.png";
import ex4ph3 from "../../../asset/4thExhibition/ph3.png";
import ex4ph4 from "../../../asset/4thExhibition/ph4.png";
import ex4ph5 from "../../../asset/4thExhibition/ph5.png";
import ex4ph6 from "../../../asset/4thExhibition/ph6.png";
import ex4ph7 from "../../../asset/4thExhibition/ph7.png";

const imageSets = {
    ex1: [ex1ph1, ex1ph2, ex1ph3, ex1ph4, ex1ph5, ex1ph6, ex1ph7, ex1ph8, ex1ph9, ex1ph10, ex1ph11, ex1ph12, ex1ph13, ex1ph14, ex1ph15],
    ex2: [ex2ph1, ex2ph2, ex2ph3, ex2ph4, ex2ph5, ex2ph6, ex2ph7, ex2ph8, ex2ph9, ex2ph10],
    ex3: [ex3ph1, ex3ph2],
    ex4: [ex4ph1, ex4ph2, ex4ph3, ex4ph4, ex4ph5, ex4ph6, ex4ph7]
}

const Drawing = () => {
  const sceneRef = useRef(null);
  const engineRef = useRef(Matter.Engine.create());
  const renderRef = useRef(null);
  const blocksRef = useRef([]); // 작은 네모들을 추적하기 위한 ref
  const imageBlocksRef = useRef([]); // 큰 네모들을 추적하기 위한 ref
  const imageBlocksCreatedRef = useRef(false); // 큰 네모 생성 여부를 추적

  const [showSlidingGrid, setShowSlidingGrid] = useState(false); // 슬라이딩 화면 상태
  const [activeImages, setActiveImages] = useState([]); // 큰 이미지 클릭 시 보여줄 이미지 리스트
  const [modalImage, setModalImage] = useState(null); // 모달 상태
  const [secondModalImage, setSecondModalImage] = useState(null); // 모달 상태

  const [sceneWidth, setSceneWidth] = useState(window.innerWidth * 0.75);
  const [sceneHeight, setSceneHeight] = useState(window.innerHeight * 0.65);

  useEffect(() => {
    const engine = engineRef.current;
    const world = engine.world;

    // 중력 설정
    engine.gravity.y = 1;

    // 씬 크기 설정
    const blockWidth = 150;
    const blockHeight = 220;
    const borderOffset = 12; // 보더 역할을 할 크기 차이
    const spacing = 50;

    // 디바이스 픽셀 비율 가져오기
    const devicePixelRatio = window.devicePixelRatio || 1;
    const renderWidth = (sceneWidth - 20) * devicePixelRatio;
    const renderHeight = (sceneHeight - 20) * devicePixelRatio;

    // 렌더러 설정
    renderRef.current = Matter.Render.create({
        element: sceneRef.current,
        engine: engine,
        options: {
            width: renderWidth / devicePixelRatio,
            height: renderHeight / devicePixelRatio,
            pixelRatio: devicePixelRatio,
            wireframes: false,
            background: 'transparent',  // 배경을 투명하게 설정
        },
    });

    Matter.Render.run(renderRef.current);
    Matter.Runner.run(Matter.Runner.create(), engine);

    // setSecondModalImage(true);
    
    // 바닥 추가
    const ground = Matter.Bodies.rectangle(
      renderWidth / 2 / devicePixelRatio,
      (renderHeight - 5) / devicePixelRatio,
      renderWidth / devicePixelRatio,
      10,
      { isStatic: true, render: { fillStyle: 'transparent', strokeStyle: 'transparent' } }
    );
    Matter.World.add(world, ground);

    // 좌우 벽 추가
    const wallThickness = 10;
    const leftWall = Matter.Bodies.rectangle(
      5 / devicePixelRatio,
      renderHeight / 2 / devicePixelRatio,
      wallThickness,
      renderHeight / devicePixelRatio,
      {
        isStatic: true,
        render: { fillStyle: 'transparent', strokeStyle: 'transparent' },
      }
    );
    const rightWall = Matter.Bodies.rectangle(
      (renderWidth - 5) / devicePixelRatio,
      renderHeight / 2 / devicePixelRatio,
      wallThickness,
      renderHeight / devicePixelRatio,
      {
        isStatic: true,
        render: { fillStyle: 'transparent', strokeStyle: 'transparent' },
      }
    );
    Matter.World.add(world, [leftWall, rightWall]);

    // 큰 네모 4개 생성 (화면 가로 가운데 세로 가운데에 배치, 50px 간격)
    const createImageBlocks = () => {
      if (imageBlocksCreatedRef.current) return;
      imageBlocksCreatedRef.current = true;

      const totalWidth = blockWidth * 4 + spacing * 3;
      const startX = (renderWidth - totalWidth * devicePixelRatio) / 2 / devicePixelRatio + blockWidth / 2;
      const centerY = renderHeight / 2 / devicePixelRatio;

      const imageUrls = [poster1, poster2, poster3, poster4];

      for (let i = 0; i < 4; i++) {
        const x = startX + i * (blockWidth + spacing);
        const y = centerY;

        // 이미지 블록 (보더 블록보다 살짝 작은 크기로 위치 맞추기)
        const imageBlock = Matter.Bodies.rectangle(x, y, blockWidth, blockHeight, {
          isStatic: true,
          render: {
            sprite: {
              texture: imageUrls[i],
              xScale: (blockWidth - borderOffset) / 150, // 이미지 크기를 약간 줄임
              yScale: (blockHeight - borderOffset) / 220, // 이미지 크기를 약간 줄임
            },
          },
        });

        imageBlocksRef.current.push(imageBlock);
        Matter.World.add(world, imageBlock); // 이미지 블록도 월드에 추가
      }
    };

    // 큰 네모는 한 번만 생성되도록 호출
    createImageBlocks();

    // 작은 네모 생성 (랜덤하게 30개는 보더 색과 동일한 색상으로)
    const createBlocks = (count) => {
      const randomIndices = new Set();
      while (randomIndices.size < 30) {
        randomIndices.add(Math.floor(Math.random() * count));
      }

      for (let i = 0; i < count; i++) {
        const blockSize = 40;

        // y 좌표를 화면 상단 바깥으로 설정해 네모들이 떨어지게 만듦
        const x = Math.random() * (renderWidth - blockSize * devicePixelRatio) / devicePixelRatio + blockSize / 2;
        const y = Math.random() * - 100; // 초기 위치를 화면 상단 바깥으로 설정

        const fillStyle = randomIndices.has(i)
          ? 'rgba(74, 166, 247, 1)'
          : 'rgba(255, 255, 255, 1)';

        const block = Matter.Bodies.rectangle(x, y, blockSize, blockSize, {
          restitution: 0.5,
          friction: 0.1,
          chamfer: { radius: 5 },
          render: {
            fillStyle: fillStyle,
            strokeStyle: 'rgba(74, 166, 247, 1)',
            lineWidth: 2,
          },
        });

        blocksRef.current.push(block);
      }
    };

    createBlocks(70);

    // 블록들을 월드에 추가
    Matter.World.add(world, [...imageBlocksRef.current, ...blocksRef.current]);

    // 마우스 컨트롤 추가
    const mouse = Matter.Mouse.create(renderRef.current.canvas);
    const mouseConstraint = Matter.MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: {
          visible: false,
        },
      },
    });

    Matter.World.add(world, mouseConstraint);
    renderRef.current.mouse = mouse;

    // 창 크기 변경 시 렌더러 및 벽 조정
    const handleResize = () => {
      const newSceneWidth = window.innerWidth * 0.75;
      const newSceneHeight = window.innerHeight * 0.65;
      const newRenderWidth = (newSceneWidth - 20) * devicePixelRatio;
      const newRenderHeight = (newSceneHeight - 20) * devicePixelRatio;

      setSceneWidth(newSceneWidth);
      setSceneHeight(newSceneHeight);

      Matter.Render.stop(renderRef.current);
      renderRef.current.canvas.width = newRenderWidth / devicePixelRatio;
      renderRef.current.canvas.height = newRenderHeight / devicePixelRatio;
      Matter.Render.run(renderRef.current);

      Matter.Body.setPosition(ground, { x: newRenderWidth / 2 / devicePixelRatio, y: newRenderHeight - 5 });
      Matter.Body.scale(ground, newRenderWidth / renderWidth, 1);

      Matter.Body.setPosition(leftWall, { x: 5 / devicePixelRatio, y: newRenderHeight / 2 / devicePixelRatio });
      Matter.Body.setPosition(rightWall, { x: newRenderWidth - 5 / devicePixelRatio, y: newRenderHeight / 2 / devicePixelRatio });
      Matter.Body.scale(leftWall, 1, newRenderHeight / renderHeight);
      Matter.Body.scale(rightWall, 1, newRenderHeight / renderHeight);
    };

    // 큰 이미지 블록 클릭 이벤트
    Matter.Events.on(mouseConstraint, 'mousedown', (event) => {
        const { mouse } = event;
        const clickedImageBlocks = Matter.Query.point(imageBlocksRef.current, mouse.position);

        if (clickedImageBlocks.length > 0) {
            const clickedIndex = imageBlocksRef.current.indexOf(clickedImageBlocks[0]);
            const clickedImage = Object.keys(imageSets)[clickedIndex];
            setActiveImages(imageSets[clickedImage]); // 클릭한 이미지의 카테고리에 속한 이미지들을 설정
            setShowSlidingGrid(true); // 슬라이딩 화면을 보여줌
        }
    });
    window.addEventListener('resize', handleResize);

    Matter.Events.on(mouseConstraint, 'mousemove', (event) => {
        const { mouse } = event;
        const hoveredBlocks = Matter.Query.point(blocksRef.current, mouse.position);
      
        if (hoveredBlocks.length > 0) {
          // 커서를 이미지로 변경
          sceneRef.current.style.cursor = `url(${grab}), pointer`;
        } else {
          sceneRef.current.style.cursor = `url(${pointer}), pointer`; // 커서를 기본으로 변경
        }
    });

    // 클린업
    return () => {
      Matter.Render.stop(renderRef.current);
      Matter.World.clear(world, false);
      Matter.Engine.clear(engine);
      renderRef.current.canvas.remove();
      renderRef.current.textures = {};

      window.removeEventListener('resize', handleResize);
    };
  }, [sceneWidth, sceneHeight]);

  useEffect(() => {
    const timer = setTimeout(() => {
        setSecondModalImage(true);
    }, 500);

    return () => clearTimeout(timer); // 컴포넌트가 언마운트될 때 타이머 제거
  }, []);

  const handleCloseSlidingGrid = () => {
    setShowSlidingGrid(false); // 슬라이딩 화면을 닫음
    setActiveImages([]); // 이미지 리스트 초기화
  };

  const handleImageClick = (img) => {
    setModalImage(img); // 클릭한 이미지를 모달로 설정
  };

  const closeModal = () => {
    setModalImage(null); // 모달을 닫음
  };

  const closeSecondModal = () => {
    setSecondModalImage(null); // 모달을 닫음
  };

  return (
    <div className="stacking-page" style={{ width: '100%', height: '100%' }}>
      <div 
        className="scene" 
        ref={sceneRef} 
        style={{ position: 'relative', width: '100%', height: '100%' }}
      >
        <div
          className={`sliding-grid ${showSlidingGrid ? 'show' : ''}`} 
          style={{ 
            position: 'absolute', 
            top: 0, 
            left: showSlidingGrid ? '30px' : '-100%', 
            width: `${sceneWidth}px`, 
            height: `${sceneHeight}px`, 
            transition: 'left 1s ease', 
            backgroundColor: '#ffffff',
            backgroundImage: 
              'linear-gradient(to right, rgba(255, 143, 233, 0.2) 1px, transparent 1px), ' +
              'linear-gradient(to bottom, rgba(20, 143, 255, 0.2) 1px, transparent 1px)',
            backgroundSize: '10px 10px', 
            zIndex: 10, 
            overflowY: 'scroll', // 세로 스크롤 가능하게 함
            cursor: `url(${cursor}) 10 10, default`
          }} 
        >
          <img 
            src={x} 
            alt="close" 
            onClick={handleCloseSlidingGrid} 
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              width: '50px',
              height: '50px',
              cursor: `url(${pointer}) 10 10, pointer`,
              zIndex: 11,
            }}
          />

          {/* 클릭된 이미지 리스트를 모눈종이 위에 표시 */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap', // 이미지를 여러 줄로 배치
                    justifyContent: 'center', // 가운데 정렬
                    alignItems: 'center',
                    marginTop: '50px',
                    cursor: `url(${cursor}) 10 10, default`
                }}
                >
                {activeImages.map((img, index) => (
                    <img 
                    key={index} 
                    src={img} 
                    alt={`exhibition-${index}`}
                    onClick={() => handleImageClick(img)} // 이미지 클릭 시 모달
                    style={{
                        margin: '10px', // 이미지 간격을 위해 margin 적용
                        width: '20vw', // 이미지 크기 유지
                        height: 'auto', 
                        borderRadius: '10px', // 보더 라디우스 적용
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        zIndex: 10,
                        cursor: `url(${pointer}) 10 10, pointer`
                    }}
                    />
                ))}
            </div>
        </div>
      </div>
      {modalImage && <Modal1 image={modalImage} onClose={closeModal} />}
      {secondModalImage && <Modal2 onClose={closeSecondModal} />}
    </div>
  );
};

export default Drawing;